import { connect } from 'react-redux';
import { logOut } from '@zippeditoolsjs/heimdal-react';
import MFA from '../../../components/profile/sections/MFA';
import { getProfile, revokeMFA } from 'core/slices/profile';
import { userProfile, isLoadingProfile } from 'core/selectors';

export default connect(
  state => ({
    userProfile: userProfile(state),
    isLoadingProfile: isLoadingProfile(state),
  }),
  { getProfile, revokeMFA, logOut },
)(MFA);
